import Promotion from '../models/promotion';

var PromotionList = Backbone.Collection.extend({ model: Promotion });

export default PromotionList;
